module.exports = __webpack_public_path__ + "static/media/accessory-7.00c95c56.png";